﻿window.isMultiSociete = false
window.cObjetSocieteMetier = function(objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "Société"; }
    this.mGetAttributBase = function () { return "la " }
    this.mGetNewLib = function () { return "Nouvelle société"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data.nom == 'undefined' || objet.data.nom == null || objet.data.nom.length == 0) { txt = "..." }
        else {
            txt = objet.data.nom
        }
        if (typeof option !='undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetRadiusImage = function () { return "0" }
    this.mGetResume = function () {
        var txt = "";
        return txt;
    }

    this.mGetIcone = function (dataTemplate) {
        return $("<i class='fas fa-building-columns' title='Société'></i>");
    }


    this.contentTemplateGrid = function (contentElement, option) {
        contentElement.empty();
    }

    this.contentTemplatePopup = function (contentElement, option) {
        if (typeof option == 'undefined') option = {}
        contentElement.empty();
        $("<div/>").appendTo(contentElement).dxCtrlContentSociete({
            bddCtrl: objet.bddRef,
            value: objet.data,
            idSelectedIndex: option.idSelectedIndex,
            idSelectedIndex: option.idSelectedIndex
        })
    }

    this.mGetTelMiseEnforme = function () {
        if (objet.data.tel_sms != null && objet.data.tel_sms.length > 0) {
            var tel = new cTelephone(objet.data.tel_code_pays, objet.data.tel_sms)
            return tel.mGetValueMiseEnForme()
        } else { return "" }
    }

    this.mGetLibHtmlVirement = function () {
        var txt = ""
        if (objet.data.iban != null && objet.data.iban.length == 0) {
            if (objet.data.nom_banque != null && objet.data.nom_banque.length == 0) txt = objet.data.nom_banque
            if (objet.data.bic != null && objet.data.bic.length == 0) {
                txt += ((txt.length > 0) ? " &bull; " : "") + "<span style='opacity:0.3;'>BIC:</span>" + objet.data.bic
            }
            txt += ((txt.length > 0) ? " &bull; " : "") + "<span style='opacity:0.3;'>IBAN:</span>" + objet.data.iban
        }
        return txt
    }

    this.mGetOrdreCheque = function () {
        var ordreCheque = objet.data.nom
        if (objet.data.ordre_cheque != null && objet.data.ordre_cheque.length > 0) ordreCheque = objet.data.ordre_cheque
        return ordreCheque
    }

    this.mGetDataAdresse = function () {
        var value = { "ad1": objet.data.ad1, "ad2": objet.data.ad2, "ad3": objet.data.ad3, "cp": objet.data.acp, "ville": objet.data.ville, "cedex": objet.data.cedex, "dpt": objet.data.dpt, "region": objet.data.region, "pays": objet.data.pays, "code_pays": objet.data.code_pays, "latitude": objet.data.latitude, "longitude": objet.data.longitude, "normalise": objet.data.normalise }
        if ((value.ad1 == null || value.ad1.length == 0) &&
            value.ad2 === null && value.ad3 == null && value.cedex == null && value.code_pays == null &&
            value.cp == null && value.dpt == null && value.latitude == null & value.longitude == null &&
            value.pays == null && value.region == null && value.ville == null) { return null }
        else { return value }
    }

    this.mGetLstCgv = function () {
        return Me.objet.bddRef.mGetArray("cgv").filter(function (o) { return o.id_societe = objet.data.id_societe })
    }
    this.mGetCgvEnCours = function () {
        var dataCgv = this.mGetLstCgv().sort(function (o1, o2) { return o2.dcr - o1.dcr })[0]
        if (typeof dataCgv == "undefined") dataCgv = null
        return dataCgv
    }
    this.mGetUrlCgv = function () {
        var url = null
        var cgv = this.mGetCgvEnCours()
        if (typeof cgv != 'undefined' && cgv != null) {
            url = parametre.url_appli + "/" + Me.objet.bddRef.nom_base + "/" + cgv.id_cgv + "/cgv"
            //url = parametre.url_appli + "/ext/page.aspx?idcgv=" + cgv.id_cgv + "&nb=" + Me.objet.bddRef.nom_base
        }
        return url
    }

    this.mGetLstLibelleChampManquantForFacture = function (idTypeCom) {
        var lstManque = []
        if (objet.data.nom == null || objet.data.nom.length == 0) lstManque.push("nom")
        if (objet.data.cp == null || objet.data.cp.length == 0) lstManque.push("code postal")
        if (objet.data.ville == null || objet.data.ville.length == 0) lstManque.push("ville")
        if (objet.data.pays == null || objet.data.pays.length == 0) lstManque.push("pays")
        if (objet.data.siret == null || objet.data.siret.length == 0) lstManque.push("siret")
        if (objet.data.siren == null || objet.data.siren.length == 0) lstManque.push("siren")
        if (objet.data.assujetti_tva == "1" && (objet.data.vat_regime == null || objet.data.vat_regime.length == 0)) lstManque.push("Régime de TVA")
        //if (objet.data.rcs == null || objet.data.rcs.length == 0) lstManque.push("rcs")
        if (objet.data.tva_intra == null || objet.data.tva_intra.length == 0) lstManque.push("tva intracommunautaire")
        if (objet.data.naf_ape == null || objet.data.naf_ape.length == 0) lstManque.push("NAF/APE")
        if (idTypeCom != 'undefined' && (idTypeCom == "4" || idTypeCom == "5")) {
        } else {
            if (objet.data.forme_juridique == null || objet.data.forme_juridique.length == 0) lstManque.push("forme juridique")
            if (objet.data.phrase_mt_indemn_forfaitaire == null || objet.data.phrase_mt_indemn_forfaitaire.length == 0) lstManque.push("phrase indemnité forfaitaire")
            if (objet.data.phrase_penalite_retard == null || objet.data.phrase_penalite_retard.length == 0) lstManque.push("phrase pénalité de retard")
            if (objet.data.delai_paiement_jour == null || objet.data.delai_paiement_jour.length == 0) lstManque.push("délais de paiement en jours")
        }
        return lstManque
    }

    this.mShowPopup = function (optionPopup) {
        if (typeof optionPopup == 'undefined') optionPopup = {}
        if (typeof optionPopup.width == 'undefined') optionPopup.width = 600
        return objet.mShowPopupInterne(optionPopup)
    }

    this.mGetLookUpForFilterBuilder = function () {
        var lstUti = []
        objet.bddRef.mGetArray("societe").forEach(function (data) {
            lstUti.push({ id: data.id_societe, nom: objet.bddRef.getObjet(data).mGetLib1() })
        })
        return {
            dataSource: lstUti,
            displayExpr: "nom",
            valueExpr: "id",
            placeholder: "Sélectionner des sociétés"
        }
    }

    this.mConnectSuperPdp = function (funcOk) {
        if (objet.bddRef.objCptCli.data.offre_essai == "1" && parametre.type_gestion_environnement == "abonnement") {
            mNotify("Vous êtes dans une offre d'essai.<br/>Vous ne pouvez pas activer la facture électronique.<br/>Veuillez vous abonner pour activer la facture électronique.", "warning", 6000)
            return
        }
        if (objet.bddRef.isDemo) {
            mNotify("Vous êtes dans un environnement de démo.<br/>Vous ne pouvez pas activer la facture électronique.", "warning", 6000)
            return
        }
        if (objet.data.has_pa == "1") {
            mNotify("Cette société est déjà connectée à SUPER PDP.<br/>Vous pouvez révoquer la connexion si vous désirez mettre à jour votre connexion.", "warning", 6000)
            return
        }

        var pop = $("<div/>").appendTo("body").dxCtrlPopupBase({
            showMaximize: false,
            height: "auto",
            width: 500,
            hideOnOutsideClick: false,
            shading: true,
            title: "<div style='line-height:1;'>Choisissez la connexion à SUPER PDP<br/>pour <b>" + objet.data.nom + "</b></div>",
            contentTemplate: function (contentElement) {
                //contentElement.css("padding-top", "0")
                var selectedValue = 0

                if (objet.bddRef.nom_base != "masc_aagest") {
                    $("<div style=''>Pour la facture électronique, " + parametre.nom + " utilise SUPER PDP. " + parametre.nom + " utilise cette plateforme pour envoyer vos factures de ventes. Cela ne concerne que vos facture d'achat. Pour la réception de vos factures d'achat, vous devez toujours utiliser le PA que vous avez choisi.</div>").appendTo(contentElement)

                    var $DivCon = $("<div style='margin:20px;padding:10px;border:" + theme.border + ";'/>").appendTo(contentElement)
                    $("<div style='font-weight:bold;font-size:120%;'>ENVOYER</b></div>").appendTo($DivCon)
                    $("<div style='font-weight:bold;'>Envoyer uniquement mes factures de vente avec <b>" + parametre.nom + "</b>.</div>").appendTo($DivCon)
                    $("<div style='font-size:80%;'>Toutes mes factures de ventes faites dans <b>" + parametre.nom + "</b> seront envoyées aux destinataires via SUPER PDP.<br/>Je garde ma plateforme actuelle pour recevoir mes factures d'achat. Aucun changement pour mes fournisseurs.</div>").appendTo($DivCon)
                } else {
                    $("<div style=''>Pour la facture électronique, " + parametre.nom + " utilise SUPER PDP. " + parametre.nom + " utilise cette plateforme pour envoyer vos factures de ventes et, si vous le désirez, gérer vos factures d'achats (en faisant de SUPER PDP votre propre plateforme agréée).</div>").appendTo(contentElement)
                    $("<a href='https://www.superpdp.tech/' target='_blank'>En savoir plus sur SUPER PDP</a>").appendTo(contentElement)

                    var $DivRadio = $("<div/>").appendTo(contentElement)
                    mRempliRadio()
                    function mRempliRadio() {
                        $DivRadio.css("height", $DivRadio.innerHeight() + "px")
                        $DivRadio.empty()
                        $("<div/>").appendTo($DivRadio).dxRadioGroup({
                            dataSource: [0, 1],
                            value: selectedValue,
                            itemTemplate: function (itemData, itemIndex, itemElement) {
                                switch (itemData) {
                                    case 0:
                                        $("<div style='font-weight:bold;font-size:120%;'>ENVOYER</b></div>").appendTo(itemElement)
                                        $("<div style='font-weight:bold;'>Envoyer uniquement mes factures de vente avec <b>" + parametre.nom + "</b>.</div>").appendTo(itemElement)
                                        $("<div style='font-size:80%;'>Toutes mes factures de ventes faites dans <b>" + parametre.nom + "</b> seront envoyées aux destinataires via SUPER PDP.<br/>Je garde ma plateforme actuelle pour recevoir mes factures d'achat. Aucun changement pour mes fournisseurs.</div>").appendTo(itemElement)
                                        break;
                                    case 1:
                                        $("<div style='font-weight:bold;font-size:120%;'>ENVOYER/RECEVOIR</b></div>").appendTo(itemElement)
                                        $("<div style='font-weight:bold;'>Envoyer mes factures de vente et recevoir mes factures d'achat avec <b>" + parametre.nom + "</b>.</div>").appendTo(itemElement)
                                        $("<div style='font-size:80%;'>&bull; Mes factures de ventes faites dans <b>" + parametre.nom + "</b> seront envoyées aux destinataires via SUPER PDP.</div>").appendTo(itemElement)
                                        $("<div style='font-size:80%;'>&bull; Mes factures d'achat seront désormais reçues et gérées directement dans <b>" + parametre.nom + "</b> (via SUPER PDP). Si j'ai déjà une autre plateforme pour la réception, ce choix déclenche un transfert : je recevrai un e-mail de Super PDP pour confirmer ce changement, puis le transfert depuis mon ancienne plateforme peut prendre jusqu'à 5 jours.</div>").appendTo(itemElement)
                                        break;
                                }
                                if (selectedValue != itemData) itemElement.css("opacity", "0.3")
                            },
                            onValueChanged: function (e) {
                                selectedValue = e.value
                                mRempliRadio()
                            }
                        }).dxRadioGroup("instance")
                        $DivRadio.css("height", "")
                    }

                    $("<div style='margin:10px;font-style:italic;font-size:80%;'>Si vous choisissez la première option (envoi uniquement), vous pourrez changer d'avis à tout moment et passer à l'option 2 en révoquant la connexion et en la recréant. Si vous avez toujours une autre plateforme pour la réception à ce moment-là, ce changement déclenchera le même transfert que celui décrit ci-dessus (e-mail de confirmation, puis jusqu'à 5 jours de délais).</div>").appendTo(contentElement)
                }
                mAddButtonOkAnnuler(contentElement,
                    function () { //ok
                        pop.hide()
                        if (selectedValue == 1) {
                            mConfirmPopup(function (contentElement) {
                                $("<div/>").appendTo(contentElement).html("Vous avez choisi de recevoir vos factures d'achat dans SUPER PDP.")
                                $("<div style='margin-top:5px;'/>").appendTo(contentElement).html("Pour confirmer cela, dans l'onglet '<b>3. Accord formel</b>', vous aurez une case à cocher avec la phrase<br/><i>&nbsp;&nbsp;&nbsp;&nbsp;'Je souhaite inscrire l’adresse ... pour recevoir des factures avec effet immédiat'</i>.")
                                $("<div style='margin-top:5px;'><b>Cochez bien cette case pour activer la réception.</b></div>").appendTo(contentElement)
                                $("<div style='margin-top:5px;margin-bottom:10px;'/>").appendTo(contentElement).html("Sans cela, vous n'aurez activé que l'envoi de vos factures de vente.")

                                $("<div class='blinkscalealways' style='color:red;text-align:center;margin:20px 0;'>Cette action résiliera votre abonnement à votre PA actuelle<br/>et fera de SUPER PDP votre PA officielle.</div>").appendTo(contentElement)
                            }, function () {
                                mGo()
                            }, "Confirmer", function () { }, "Annuler", null, true, "Recevoir ces factures avec SUPER PDP", 600)
                        } else { mGo() }

                        function mGo() {
                            jaugeDemarrage.option("message", "Veuillez patienter pendant la connexion à superPDP<br/>Veuillez suivre les instructions sur la fenêtre qui vient de s'ouvrir")
                            jaugeDemarrage.option("onCancel", function () { jaugeDemarrage.mHide() })
                            jaugeDemarrage.mShow()
                            objet.bddRef.mAjaxCall({
                                command: "superpdpgeturloauth",
                                id_societe: objet.data.id_societe,
                                recevoir: selectedValue
                            }, function (data) {
                                window.open(data.urloauth, "_blank")

                                mSurveille()
                                function mSurveille() {
                                    objet.bddRef.mReloadTable("societe", function () {
                                        var dataSociete = objet.bddRef.getObjet("societe", objet.data.id_societe).data
                                        if (dataSociete.has_pa == "1") {
                                            mConfirmPopup("<div>La connexion à SUPER PDP a été confirmée.</div>", function () {
                                            }, "Ok", null, null, null, true, "Facture électronique")
                                            //mNotify("La connexion a SUPER PDP a été confirmée.", "success", 6000)
                                            jaugeDemarrage.mHide()
                                            if (funcOk) funcOk()
                                        } else {
                                            window.setTimeout(function () { mSurveille() }, 1000)
                                        }
                                    })
                                }
                            })
                        }

                    },
                    function () { //annuler
                        pop.hide();
                    }, "Annuler").table.css("margin-top", "20px")

            }
        }).dxCtrlPopupBase("instance")
        pop.show()
    }

}